<script>
  import _dropdownitem from '../mixins/_dropdown-item'

  export default {
    name: 'NavbarNavDropdownItem',
    mixins: [_dropdownitem]
  }
</script>



// WEBPACK FOOTER //
// navbar-nav-dropdown-item.vue?15a3f349